import React from 'react';
import $ from 'jquery';

import getPpsUrl from '../../common/ppsUrl';

const sources = require('../../config.json');

const formatSoldDate = (value) => {
	const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
	if (!match) {
		return "-";
	}
	return `${match[3]}/${match[2]}/${match[1]}`;
};

const formatSoldPrice = (value) => {
	const price = parseInt(value, 10);
	if (!price || price <= 0) {
		return "-";
	}
	return "$" + price.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');
};

class SoldLots extends React.Component {
	constructor(props) {
		super(props);
		this.state = { lots: null };
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const url = sources.landsearch + "?ts=" + new Date().getTime();
		$.ajax({ url: url, dataType: 'json' }).done((data) => {
			const lots = (data.lots || []).filter((lot) => {
				return parseInt(lot.status, 10) === 2 && getPpsUrl(lot.pps_url);
			});
			lots.sort((a, b) => {
				if (!a.sold_date) return 1;
				if (!b.sold_date) return -1;
				return a.sold_date < b.sold_date ? 1 : a.sold_date > b.sold_date ? -1 : 0;
			});
			this.setState({ lots: lots });
		});
	}

	render() {
		const lots = this.state.lots;
		return (
			<div className="sold-lots">
				<button type="button" className="sold-lots-back" onClick={this.props.onBack}>&lt; Go Back</button>
				<h1 className="title f3 f4-md m-b-2">Sold Lots</h1>
				{lots === null ? <p className="small-grey-font">Loading sold lots...</p> : (
					<div className="sold-lots-table">
						<div className="sold-lots-row sold-lots-head">
							<div className="sold-lots-cell">Lot number</div>
							<div className="sold-lots-cell">Stage</div>
							<div className="sold-lots-cell">Sold Price</div>
							<div className="sold-lots-cell">Sold Date</div>
							<div className="sold-lots-cell sold-lots-pps">PPS</div>
						</div>
						{lots.length === 0 ? (
							<p className="small-grey-font sold-lots-empty">There are no sold lots to display.</p>
						) : lots.map((lot) => (
							<div className="sold-lots-row" key={lot.id}>
								<div className="sold-lots-cell">{lot.name}</div>
								<div className="sold-lots-cell">{lot.stage || "-"}</div>
								<div className="sold-lots-cell">{formatSoldPrice(lot.sold_price)}</div>
								<div className="sold-lots-cell">{formatSoldDate(lot.sold_date)}</div>
								<div className="sold-lots-cell sold-lots-pps">
									<a className="pps-download" href={getPpsUrl(lot.pps_url)} target="_blank" rel="noopener noreferrer" title="Download PPS" aria-label="Download PPS">
										<i className="icon icon--download-alt"></i>
									</a>
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}
}

export default SoldLots;



/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/SoldLots.js
 **/